/* RESPONSIBLE TEAM: team-ai-insights */
import OptimizeSuggestions from 'embercom/routes/apps/app/automation/fin-ai-agent/analyze/optimize-suggestions';
import type Transition from '@ember/routing/transition';

export default class FinStandaloneOptimizeSuggestions extends OptimizeSuggestions {
  analytics = {
    section: 'standalone',
    place: 'optimize-suggestions',
  };

  templateName = 'apps/app/automation/fin-ai-agent/analyze/optimize-suggestions';
  controllerName = 'apps/app/automation/fin-ai-agent/analyze/optimize-suggestions';
  routeWhenNotOptedIn = 'apps.app.standalone.setup';

  beforeModel(transition: Transition) {
    // Redirect suite users to their route
    if (!this.appService.app.isStandaloneApp) {
      transition.abort();
      this.router.transitionTo('apps.app.automation.fin-ai-agent.analyze.optimize-suggestions');
      return;
    }
  }
}
